export const EMPTY_VIDEO = {
    title: "", region: "Highlands", summary: "", video_id: "", duration: "",
    featured: false, exclusive: false, thumb: "", lat: 56.5, lng: -4.0,
};
export const REGIONS = ["Highlands", "Islands", "Cities"];

/* -------------------------------------------------------------------------- */
/* Branding (logo upload)                                                     */
